import { Show, createMemo } from "solid-js";

import { Button } from "@/components/Base/Button/Button.tsx";
import GradientBorderButton from "@/components/Base/GradientBorderButton/index.tsx";
import Icon from "@/components/Icon";
import { getImageAltByLang } from "@/constants/seo-constants.ts";
import { useRouter } from "@/hooks/useRouter.tsx";
import { getLocale, useI18n } from "@/i18n";
import BonusDropdownMenu from "@/layouts/pc/components/Header/BonusDropdownMenu.tsx";
import { getImgurl } from "@/lib/resFolder.ts";
import { sdkManager } from "@/lib/sdk/sdkManager.ts";
import { cn } from "@/lib/tailwindcssTool.ts";
import { getWebsiteConfigV2 } from "@/stores/configStore.ts";
import { userStore } from "@/stores/userStore.ts";

import HeaderWallet from "./HeaderWallet.tsx";

export default function HomeHeader(props: {
  isOpen: boolean;
  downloadAppBarHeight: number;
  onToggleOpen: (isOpen: boolean) => void;
}) {
  const { push } = useRouter();
  const { t } = useI18n();
  const isLogin = createMemo(() => userStore.isLogin);

  return (
    <div class="flex h-full w-full items-center justify-between px-3 transition-colors duration-300 ease-in-out">
      {/* Logo */}
      <div class="flex items-center">
        {/* <Link href="/"> */}
        <GradientBorderButton
          wrapClass="from-[var(--colors-surface-bg-7)] to-[var(--colors-surface-bg-6)] !shrink-0"
          borderClass="from-(--colors-border-icon-top5) to-(--colors-border-icon-bottom10)"
          onClick={() => props.onToggleOpen(!props.isOpen)}
        >
          <Icon
            name="thumb"
            wrapperClass="w-8 h-8"
            class="h-4 w-4"
            color="var(--colors-icon-btn-default)"
          />
        </GradientBorderButton>

        <img
          src={`/${__APP_NAME__}/images/logo/logo.png`}
          width={"auto"}
          height={30}
          alt={getImageAltByLang("logo")}
          class="ml-2 h-[30px] w-auto shrink-0"
          onClick={() => {
            push("/");
            sdkManager.tdReportEvent("logo_nav_click", {
              source: window.location.pathname,
            });
          }}
        />
      </div>

      <Show when={!isLogin()} fallback={<></>}>
        <div class="flex items-center gap-[10px]">
          <Button
            variant="default"
            size="default"
            class="flex h-[33px] items-center justify-center rounded-[8px] bg-gradient-to-t from-[var(--colors-btn-border-fade-5)] to-[var(--colors-btn-border-fade-0)] p-[1px] shadow-[0_4px_10.7px_0_rgba(0,0,0,0.25)]"
            onClick={() => push("login")}
          >
            <div class="color-[var(--colors-text-primary)] flex h-full w-full items-center justify-center rounded-[8px] bg-gradient-to-t from-[var(--colors-surface-bg-7)] to-[var(--colors-surface-bg-9)] px-4 text-[13px] font-[700] leading-[13px]">
              {t("auth.sign_in")}
            </div>
          </Button>
          <Button
            size="default"
            class="bg-main-linear border-(--colors-btn-border-default) h-[33px] rounded-[8px] border px-4 text-[13px] font-bold leading-[13px] text-[var(--colors-text-brand)]"
            onClick={() => push("register")}
          >
            {t("auth.sign_up")}
            <Show
              when={getWebsiteConfigV2()?.registerRewardSwitch}
              fallback={<></>}
            >
              <div class="absolute right-[12px] top-[46px]">
                <img
                  src={getImgurl(
                    `top-${getLocale()}.png`,
                    "common/home/deposit-act/locale",
                  )}
                  class={cn("h-[30px] shrink-0")}
                />
              </div>
            </Show>
          </Button>
        </div>
      </Show>

      <Show when={isLogin()} fallback={<></>}>
        <div class="flex gap-1">
          <HeaderWallet downloadAppBarHeight={props.downloadAppBarHeight} />
          {/* 奖金中心 */}
          <BonusDropdownMenu
            downloadAppBarHeight={props.downloadAppBarHeight}
          />
        </div>
      </Show>
    </div>
  );
}
